<template>
  <figure class="logo">
    <img class="dark" src="../assets/images/LogoDark.png"/>
  </figure>
</template>

<style scoped>

.logo {
  padding-inline: 16px;
}

</style>